import { Swiper } from "swiper";
import type { SwiperOptions } from "swiper/types";
import { Navigation, Pagination } from "swiper/modules";

export default class FeaturedResellersSlider extends HTMLElement {
  private swiper: Swiper | null = null;

  connectedCallback() {
    this.initStoreLinks();

    if (this.swiper) {
      return;
    }

    const $el = this.querySelector<HTMLElement>(".featured-resellers__slider");

    if (!$el) {
      return;
    }

    if (($el as any).swiper as Swiper) {
      this.swiper = ($el as any).swiper as Swiper;
      return;
    }

    const $elPrev = this.querySelector<HTMLElement>(".featured-resellers__nav--prev");
    const $elNext = this.querySelector<HTMLElement>(".featured-resellers__nav--next");
    const $elPagination = this.querySelector<HTMLElement>(".featured-resellers__dots");

    const swiperParams: SwiperOptions = {
      modules: [Navigation, Pagination],
      slidesPerView: "auto",
      spaceBetween: 16,
      centeredSlides: false,
      loop: false,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    };

    if ($elPrev && $elNext) {
      swiperParams.navigation = {
        nextEl: $elNext,
        prevEl: $elPrev,
      };
    }

    if ($elPagination) {
      swiperParams.pagination = {
        el: $elPagination,
        clickable: true,
        bulletClass: "featured-resellers__dot",
        bulletActiveClass: "featured-resellers__dot--active",
      };
    }

    this.swiper = new Swiper($el, swiperParams);

    this.updateNavVisibility();
    this.swiper.on("resize", () => this.updateNavVisibility());
  }

  private initStoreLinks(): void {
    this.querySelectorAll<HTMLButtonElement>("button[data-store-name]").forEach(
      (btn) => {
        btn.addEventListener("click", () => {
          const images: string[] = [];
          if (btn.dataset.storeImage) images.push(btn.dataset.storeImage);
          if (btn.dataset['storeImage-2']) images.push(btn.dataset['storeImage-2']);
          if (btn.dataset['storeImage-3']) images.push(btn.dataset['storeImage-3']);

          const storeData = {
            name: btn.dataset.storeDisplayName || btn.dataset.storeName || "",
            address: btn.dataset.storeAddress || "",
            hours: btn.dataset.storeHours || "",
            timezone: btn.dataset.storeTimezone || "",
            lat: btn.dataset.storeLat || "",
            lng: btn.dataset.storeLng || "",
            images,
          };

          const modal = document.querySelector<any>("reseller-modal");
          if (modal && typeof modal.open === "function") {
            modal.open(storeData);
          }
        });
      },
    );
  }

  private updateNavVisibility(): void {
    if (!this.swiper) return;
    const count = this.swiper.slides.length;
    const perView =
      typeof this.swiper.params.slidesPerView === "number"
        ? this.swiper.params.slidesPerView
        : 1;
    const hideNav = count <= perView;
    this.classList.toggle("featured-resellers__slider-wrapper--nav-hidden", hideNav);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}
